export const environment = {
    development: true,
    graphqlEndpoint: 'https://wasserzaehler-backend.dev.aks.euv-stadtbetrieb.de/api/graphql',
};
